<template>
  <div id="cur">
<!--    <div class="bg-color-black">-->
      <div class="d-flex pt-2 pl-2">
         <span class="icon-cube" style="color:#5cd9e8;font-size: 0.3rem">
           <span class="fs-xl text mx-2" style="font-size: 0.25rem;color: #ffffff">交易金额</span>
        </span>
      </div>
      <div style="width: 100%;font-size: 20px;color: #4c9bfd;padding:0.2rem;"><i class="icon-dot" style="color: #ed3f35"></i>交易金额<span style="font-size: 30px;color: #ffffff;padding: 0 0.1rem">{{toThousands(allAmount)}}</span>元</div>
      <div class="d-flex jc-center" style="clear: both;width:100%;height:80%">
          <div id="mChart" style="width: 100%;height:100%"></div>
      </div>

    </div>
<!--  </div>-->
</template>

<script>
import sciApi from '@/api/index.js'
let Chart
export default {
  data() {
    return {
      tag:'',
      options:{},
      Num:{
        '知识产权':0,
        '法律服务':0,
        '政策申报':0,
        '工商财税':0,
        '科技金融':0,
        '检验检测':0,
        '科技咨询':0,
        '设备共享':0,
        '技研中心':0,
      },
      allAmount:0,
      allAmountList:[],

    };
  },
  watch:{
    setregion:{
      immediate: true,
      deep: true,
      handler(val) {
        this.tag = val

      },
    },
    tag:{
      immediate: false,
      deep: true,
      handler(val) {
        console.log(val,'val')
        this.init().then(()=>{
          let num= Object.values(this.Num)
          this.options.series[0].data=num
          Chart.setOption(JSON.parse(JSON.stringify(this.options)),true);
        })
      },
    },
  },
  computed:{
    setregion() {
      return this.$store.state.region
    }
  },
  mounted() {
    this.tag=''
    this.init().then(()=>{
      let num= Object.values(this.Num)
      this.options.series[0].data=num
      Chart.setOption(JSON.parse(JSON.stringify(this.options)),true);
    })
    this.options = {
      tooltip: {
        // 触发类型  经过轴触发axis  经过轴触发item
        trigger: 'axis',
        // 轴触发提示才有效
        axisPointer: {
          // 默认为直线，可选为：'line' 线效果 | 'shadow' 阴影效果
          type: 'line'
        }
      },
      grid: {
        // 距离 上右下左 的距离
        left: '3%',
        right: '4%',
        bottom: '10%',
        top:'15%',
        // 大小是否包含文本【类似于boxsizing】
        containLabel: true,
        //显示边框
        show: false,
        //边框颜色
        borderColor: 'rgba(0, 240, 255, 0.3)'
      },
      xAxis: {
        // 使用类目，必须有data属性

        // 使用 data 中的数据设为刻度文字
        type: 'category',
        data: [
          '知识产权',
        '法律服务',
        '政策申报',
        '工商财税',
        '科技金融',
        '检验检测',
        '科技咨询',
        '设备共享',
        '技研中心',
        ],
        // 刻度设置
        axisTick: {
          // true意思：图形在刻度中间
          // false意思：图形在刻度之间
          alignWithLabel: false,
          show: false
        },
        axisLine:{
          show:true,
          lineStyle:{
            color:'#4c9bfd'
          },

        },
        //文字
        axisLabel: {
          color: '#4c9bfd',
          interval: 0,
          rotate: 30
        },
        splitLine: {
          show:false,
          lineStyle: {
            color: '#4c9bfd',
            show:true
          }
        }
      },
      yAxis: {
        type: 'value',
        boundaryGap: false,
        // 使用数据的值设为刻度文字
        name: "单位（元）",
        nameTextStyle: {
          nameLocation: "start",
        },
        axisTick: {
          // true意思：图形在刻度中间
          // false意思：图形在刻度之间
          alignWithLabel: false,
          show: false

        }, //坐标线
        axisLine:{
          show:true,
          lineStyle:{
            color:'#4c9bfd'
          }},
        //文字
        axisLabel: {
          color: '#4c9bfd',
          fontSize: '14',

        },
        splitLine: {
          show:false,
          lineStyle: {
            color: '#4c9bfd',
            show:true
          }
        },
      },
      series: [{
        smooth: true,
        lineStyle: {
          color: '#4c9bfd',
          width: 2
        },
        areaStyle: {
          normal: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              // { offset: 0, color: "#956FD4" },
              // { offset: 1, color: "#3EACE5" }
              { offset: 1, color: "rgba(35,184,210,0.6)"}, // 1 结束颜色
              { offset: 0, color: "rgba(35,184,210,0)" }  // 0 起始颜色
            ])
          }
        },
        label: {
          show: true,
          position: 'top',
          color:'#fff',
        },
        data: [],
        type: 'line'
      }]
    }
    this.drawLine();
  },
  methods: {
    toThousands(num) {
      return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    },
    async init(){
      // await sciApi.selectMall({})
      //总金额
      const that = this;
      await sciApi.selectTechnology({level1:"384354211555599101",level2:"384354211555599103",pageSize: 1000,pageNum: 1}).then((data)=>{
        // data 就是接口返回值
        this.allAmountList = data.list || []
        if(this.tag!==''){
          this.allAmountList.forEach((item) => {
            if(item.mapAreaDisplay == that.tag)
            {
              that.Num[item.level3Display] += parseInt(item.mapNum);
            }else {
              that.Num[item.level3Display] = 0;
            }
          })
        }else {
          this.allAmountList.forEach((item) => {
            this.allAmount += parseInt(item.mapNum)
            that.Num[item.level3Display] += parseInt(item.mapNum);
          })
        }
      })

    },
    drawLine:function (){
      Chart = this.$echarts.init(document.getElementById('mChart'))
      Chart.setOption(JSON.parse(JSON.stringify(this.options)));
      // option && myChart.setOption(option);
    },
  }
};
</script>

<style lang="scss">
#cur {
  padding: 0.2rem;
  height:100%;
  width: 100%;
  //border-radius: 0.0625rem;
  .bg-color-black {
    //padding: 0.0625rem;
    //height: auto;
    //border-radius: 0.125rem;
  }
  .text {
    color: #c3cbde;
  }
  .chart-box {
    margin-top: 0.2rem;
    width: 2.125rem;
    height: 2.125rem;
    .active-ring-name {
      padding-top: 0.125rem;
    }
  }

  .bottom-data {
    .item-box {
      float: left;
      position: relative;
      width: 33%;
      color: #d3d6dd;
      // 金币
      .coin {
        position: absolute;
        left: 0.1rem;
        top: 0.2125rem;
        font-size: 0.25rem;
        color: #ffc107;
      }
      .colorYellow {
        color: yellowgreen;
      }
    }
  }
}
</style>